// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d05462c3","453":"83ed2dbf","455":"cb0780ee"}[chunkId] + ".chunk.js";
};